import { FIELD_TYPES } from './constants';
import { BRANCHING_FIELD_TYPES } from './conditionalConstants';
import { convertDropdownValueToKey } from './idUtils';

export const getAnswersForField = (field) => {
  switch (field.type) {
    case FIELD_TYPES.RADIO_BUTTON:
      return Object.values(field.editors.radioButtonConfig.options).map((option) => option.value);
    case FIELD_TYPES.DROPDOWN:
      return Object.values(field.editors.dropdownConfig.options).map((option) => option.value);
    default:
      return [];
  }
};

export const filterAnswersByActive = (answers, field) => {
  if (!BRANCHING_FIELD_TYPES.includes(field.type)) return answers;

  let config;
  if (field.type === FIELD_TYPES.DROPDOWN) {
    config = field.editors.dropdownConfig;
  } else {
    config = field.editors.radioButtonConfig;
  }
  return answers.filter((answer) => config.options[convertDropdownValueToKey(answer)]?.shouldDisplay !== false);
};

export const mapAnswersToUnfilteredIndices = (filteredAnswers, unfilteredAnswers) => {
  if (filteredAnswers.length === unfilteredAnswers.length) {
    return filteredAnswers.map((value, index) => ({ value, index }));
  }
  return filteredAnswers.map((value) => ({ value, index: unfilteredAnswers.indexOf(value) }));
};
